import MainLayout from 'Components/Layout/MainLayout';
import {Button, message, Space, Spin, Tag} from 'antd';
import {PlusOutlined} from '@ant-design/icons';
import React, {useRef} from 'react';
import Style from './index.module.scss';
import TableRender, {ProColumnsType, TableContext} from 'table-render';
import useTable from '../../../../Utils/Hooks/useTable';
import {ChangePlansStatus, getPlansPage, PlansData} from '../service';
import {useDict} from '../dict';
import useModalHandler from '../../../../Utils/Hooks/useModalHandler';
import EditModal from './Components/EditModal';
import SelectDict from '../../../../Features/Select/SelectDict';
import ProTable from '../../../../Components/ProTable';
import {Status} from '../../../../Services/common';
import useRequestFn from '../../../../Utils/Hooks/useRequestFn';
import {errorMessage} from '../../../../Utils/common';

export default function UserManage() {
    const {tableInit} = useTable(getPlansPage, {pageSize: 999});
    const tableRef = useRef<TableContext>(null);
    const dict = useDict();

    const editModal = useModalHandler({component: EditModal});

    function reload(stay = true) {
        tableRef?.current?.refresh({
            stay,
        });
    }

    function onEditOk() {
        editModal.close();
        reload();
    }

    const toolBar = (
        <div className={Style.toolBar}>
            <Space>
                <Button
                    type="primary"
                    onClick={() =>
                        editModal.open({
                            onOk: onEditOk,
                        })
                    }
                    icon={<PlusOutlined />}>
                    新增
                </Button>
            </Space>
        </div>
    );

    const schema = {
        type: 'object',
        labelWidth: 80,
        properties: {
            name: {
                title: '名称',
                type: 'string',
            },
            status: {
                title: '状态',
                type: 'string',
                widget: 'SelectDict',
                props: {
                    options: dict.Status.data,
                },
            },
            type: {
                title: '方案类型',
                type: 'string',
                widget: 'SelectDict',
                props: {
                    options: dict.ScenarioType.data,
                },
            },
        },
    };

    const [changeStatusAction, {loading: changeLoading}] =
        useRequestFn(ChangePlansStatus);

    async function changeStatus(id: string, status: Status) {
        try {
            await changeStatusAction(id, status);
            await reload();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    const columns: ProColumnsType<PlansData> = [
        {title: '序号', render: (_, _item, index) => index + 1, width: 80},
        {title: '方案名称', dataIndex: 'name', width: 120},
        {title: '编码', dataIndex: 'code', width: 120},
        {
            title: '服务范围',
            dataIndex: 'serviceList',
            render: (name, item) => (
                <div>
                    {item.serviceList.map(tag => (
                        <Tag key={tag.id}>{tag.name}</Tag>
                    ))}
                </div>
            ),
        },
        {
            title: '方案类型',
            dataIndex: 'type',
            render: dict.ScenarioType.getName,
            width: 120,
        },
        {title: '方案创建人', dataIndex: 'createUser', width: 140},
        {title: '套餐说明', dataIndex: 'remark', width: 180},
        {
            title: '状态',
            dataIndex: 'status',
            render: dict.Status.getName,
            width: 80,
        },
        {title: '方案创建时间', dataIndex: 'createTime'},
        {
            title: '操作',
            dataIndex: 'id',
            align: 'center',
            fixed: 'right',
            render: (id: string, item) => (
                <ProTable.Operate>
                    <Button
                        size="small"
                        type="link"
                        onClick={() =>
                            editModal.open({
                                id,
                                onOk: onEditOk,
                            })
                        }>
                        编辑
                    </Button>
                    <Button
                        size="small"
                        type="link"
                        onClick={() =>
                            changeStatus(
                                id,
                                item.status === Status.Freeze
                                    ? Status.Normal
                                    : Status.Freeze,
                            )
                        }>
                        {item.status === Status.Freeze ? '启用' : '停用'}
                    </Button>
                </ProTable.Operate>
            ),
        },
    ];

    return (
        <MainLayout.SpaceWrapper padding>
            <Spin spinning={changeLoading}>
                <TableRender
                    pageChangeWithRequest={false}
                    rowKey="id"
                    ref={tableRef}
                    search={{schema, widgets: {SelectDict}}}
                    columns={columns}
                    toolbarRender={toolBar}
                    scroll={{x: 'max-content'}}
                    {...tableInit()}
                />
            </Spin>

            {editModal.render()}
        </MainLayout.SpaceWrapper>
    );
}
